import React from 'react';
import { Form, Checkbox } from 'antd';

const FormItem = Form.Item;

const EvalRequiredItem = ({ actionDisable, value, handleChange }) => (
        <FormItem label="必填项配置">
                <div>
                        <Checkbox
                                disabled={actionDisable}
                                checked={value != null && value.indexOf("weekNameon") !== -1 ? true : false}
                                onChange={(event) => {
                                        const evalRequiredItem = event.target.checked ? 'weekNameon' : 'weekNameoff';
                                        handleChange({ evalRequiredItem });
                                }}></Checkbox>星期必填&ensp;
                        <Checkbox
                                disabled={actionDisable}
                                checked={value != null && value.indexOf("weekNumon") !== -1 ? true : false}
                                onChange={(event) => {
                                        const evalRequiredItem = event.target.checked ? 'weekNumon' : 'weekNumoff';
                                        handleChange({ evalRequiredItem });
                                }}></Checkbox>周次必填&ensp;
                        <Checkbox
                                disabled={actionDisable}
                                checked={value != null && value.indexOf("lessonNumon") !== -1 ? true : false}
                                onChange={(event) => {
                                        const evalRequiredItem = event.target.checked ? 'lessonNumon' : 'lessonNumoff';
                                        handleChange({ evalRequiredItem });
                                }}></Checkbox>节次必填&ensp;
                        <Checkbox
                                disabled={actionDisable}
                                checked={value != null && value.indexOf("pingyuon") !== -1 ? true : false}
                                onChange={(event) => {
                                        const evalRequiredItem = event.target.checked ? 'pingyuon' : 'pingyuoff';
                                        handleChange({ evalRequiredItem });
                                }}></Checkbox>评语必填&ensp;
                </div>
                <div>
                        <Checkbox
                                disabled={actionDisable}
                                checked={value != null && value.indexOf("classes") !== -1 ? true : false}
                                onChange={(event) => {
                                        const evalRequiredItem = event.target.checked ? 'classesNameon' : 'classesNameoff';
                                        handleChange({ evalRequiredItem });
                                }}></Checkbox>班级必填&ensp;
                        <Checkbox
                                disabled={actionDisable}
                                checked={value != null && value.indexOf("course") !== -1 ? true : false}
                                onChange={(event) => {
                                        const evalRequiredItem = event.target.checked ? 'courseNameon' : 'courseNameoff';
                                        handleChange({ evalRequiredItem });
                                }}></Checkbox>课程必填&ensp;
                        <Checkbox
                                disabled={actionDisable}
                                checked={value != null && value.indexOf("lessonAddress") !== -1 ? true : false}
                                onChange={(event) => {
                                        const evalRequiredItem = event.target.checked ? 'lessonAddresson' : 'lessonAddressoff';
                                        handleChange({ evalRequiredItem });
                                }}></Checkbox>上课地点必填&ensp;
                        <Checkbox
                                disabled={actionDisable}
                                checked={value != null && value.indexOf("uploadfileon") !== -1 ? true : false}
                                onChange={(event) => {
                                        const evalRequiredItem = event.target.checked ? 'uploadfileon' : 'uploadfileoff';
                                        handleChange({ evalRequiredItem });
                                }}></Checkbox>附件上传必填&ensp;
                </div>
        </FormItem>
);

export default EvalRequiredItem;
